// centralized API configuration
// loaded before all other scripts in theme.liquid
(function() {
  var isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');

  window.GD_API_BASE = isLocal
    ? 'http://localhost:3300'
    : 'https://api.golfdaddyapi.com';

  // the no-auth /public/* routes (return links) are served by the coach
  // gateway, not the mobile one -- api.golfdaddyapi.com does not map them
  window.GD_PUBLIC_API_BASE = isLocal
    ? 'http://localhost:3300'
    : 'https://coach.golfdaddyapi.com';
})();
